/**
 * Created by RKL on 13/08/2015.
 */
define('caccountOrderStatusTabController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'caccountOrderStatusTabView',
  'orderStatusCreateEditLayoutView',
  'entities/caccounts/orderstatus'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  CreateEditLayoutView
) {
  'use strict';

  var CAccountsOrderStatusTabController = {
    showTab: function(data) {
      this.secId = data.type === 'customer' ? data.id : null;
      this.data = data;

      this.view = new View();

      this.view.listenTo(this.view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
      this.view.listenTo(this.view, 'onCreateOrderStatus', _.bind(this.onCreateOrderStatus, this));
      this.view.listenTo(this.view, 'onDelete', _.bind(this.onDeleteOrderStatus, this));

      App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('tabContent').show(this.view);
    },

    onGridLoaded:function() {
      var data = {
          url: App.request('orderstatus-tab:get-url', this.secId),
          rowCountUrl: App.request('orderstatus-tab:row-count-url', this.secId),
          type: this.data.type
        };
        
      this.view.displayGrid(data, true);
    },

    onCreateOrderStatus: function() {
        var createEditView = new CreateEditLayoutView({
            orderStatusModel: App.request('orderstatus-tab:new-model', {tag: 'order'}),
            newItem: true
        });
        createEditView.show({
            title: _.i18n('orderstatus.new')
        });
    },

    /*onEditOrderStatus: function(model) {
      var createEditView = new CreateEditLayoutView({
          orderStatusModel: App.request('orderstatus-tab:new-model')
      });
      createEditView.show({
          title: _.i18n('orderstatus.edit')
      });
    },*/

    onDeleteOrderStatus: function(orderStatusId) {
      var that = this,
        deleteRequest;

      bootbox.confirm(_.i18n('warning.deleteOrderStatus'), function (result) {
        if (result) {
          deleteRequest = App.request('orderstatus-tab:delete', orderStatusId);
          $.when(deleteRequest).done(function() {
            that.view.updatePagination('reloadGrid');
          });
        }
      });
    }
  };

  module.exports = CAccountsOrderStatusTabController;
});
